module.exports = __webpack_public_path__ + "img/ics_o_person.198b4b04.svg";